import { createFileRoute } from "@tanstack/react-router";
import { ShoppingListPage } from "@/pages/ShoppingList/ShoppingListPage.tsx";

// Route principale des listes de courses
export const Route = createFileRoute("/house/shopping-list/")({
  component: ShoppingListPage,
});
